module.exports = __webpack_public_path__ + "static/media/crash_6.e6393ad3.mp3";